/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e1222211136788ab6da2ea409faea6e894c55e2d";
